import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  photos: [],
  loading: false,
  error: null,
  fetched: false,
};

const photoSlice = createSlice({
  name: "photos",
  initialState,
  reducers: {
    fetchPhotosRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.photos= [];
      state.fetched= false;
    },
    fetchPhotosSuccess: (state, action) => {
      state.loading = false;
      state.photos = action.payload;
      state.fetched= true;
    },
    fetchPhotosFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.photos= [];
      state.fetched= true;
    },
  },
});

export const { fetchPhotosRequest, fetchPhotosSuccess, fetchPhotosFailure } =
  photoSlice.actions;

export default photoSlice.reducer;
